import { howItWorks } from '../data/mock';

export const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="section-dark wood-bg">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span 
            className="inline-block px-4 py-2 rounded-full mb-4 font-display text-sm uppercase tracking-widest"
            style={{ 
              background: 'rgba(212, 168, 75, 0.15)',
              border: '1px solid var(--border-gold)',
              color: 'var(--gold-primary)'
            }}
          >
            Simple Process
          </span>
          <h2 className="heading-1 text-gold mb-4">
            How It Works
          </h2>
          <p 
            className="body-large max-w-2xl mx-auto"
            style={{ color: 'var(--text-muted)' }}
          >
            Two simple steps to a borer-free home.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {howItWorks.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < howItWorks.length - 1 && (
                <div 
                  className="hidden md:block absolute top-12 left-1/2 w-full h-0.5"
                  style={{ 
                    background: 'linear-gradient(to right, var(--gold-primary), transparent)',
                    transform: 'translateX(50%)'
                  }}
                />
              )}
              
              <div className="card-wood text-center relative z-10">
                {/* Step Number */}
                <div 
                  className="inline-flex items-center justify-center w-20 h-20 rounded-full mb-4 font-display text-2xl font-bold"
                  style={{ 
                    background: 'linear-gradient(135deg, var(--gold-dark), var(--gold-primary))',
                    color: 'var(--bg-dark)'
                  }}
                >
                  {step.step}
                </div>
                <h3 
                  className="heading-3 mb-3"
                  style={{ color: 'var(--gold-primary)' }}
                >
                  {step.title}
                </h3>
                <p 
                  className="body-small"
                  style={{ color: 'var(--text-muted)' }}
                >
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
